import { motion } from "framer-motion";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
`;
const ReactionButton = styled.button`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 8px;
  align-items: center;
  background: transparent;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid transparent;
  type: button;
  box-shadow: none;
  border-radius: 4px;
  min-width: 64px;
  height: 32px;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) =>
      theme.Color.elevation.surface["surface-primary-hover"].value};
  }
  &:active {
    background: ${({ theme }) =>
      theme.Color.background.brand.subtlest["default-active"].value};
    border-color: ${({ theme }) =>
      theme.Color.border["ui-border-default"].value};
  }
`;
const UserReactedButton = styled(ReactionButton)<{
  $background: string;
  $hoverBackground: string;
}>`
  min-width: 78px;
  height: 32px;
  border-radius: 4px;
  gap: 8px;
  padding: 6px 8px;

  background: ${({ $background }) => $background};
  &:hover {
    background: ${({ $hoverBackground }) => $hoverBackground};
  }
  &:active {
    background: ${({ $hoverBackground }) => $hoverBackground};};
  }
`;

const EmojisContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0px;
`;
const UserReactedEmojiContainer = styled(EmojisContainer)`
  position: absolute;
  transform: rotate(13.5deg);
  top: -10px;
  right: -6px;
  z-index: 0;
`;
const EmojiWrapper = styled.span<{ $index: number }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  aspect-ratio: 1/1;
  height: 16px;
  width: 16px;
  border: 0.4px solid
    ${({ theme }) => theme.Color.border["ui-border-on-bold"].value};
  background: ${({ theme }) => theme.Color.background.neutral.default.value};
  position: relative;
  margin-left: ${({ $index }) => ($index > 0 ? -2.5 : 0)}px;
`;
const Emoji = styled(motion.span)``;
const CounterWrapper = styled.div`
  z-index: -1;
  position: absolute;
  left: calc(100% - 6px);
`;

export const ReactionButtonStyles = {
  Container,
  ReactionButton,
  UserReactedButton,
  EmojisContainer,
  UserReactedEmojiContainer,
  EmojiWrapper,
  CounterWrapper,
  Emoji,
};
